require('./externalTransferFundDetails.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classNames = require('classnames');
// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ helpers
const { toCamelCase } = require('utilities/stringHelper');
const { formatWithoutRound, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;

// @ constants
const {
    BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL,
    BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL_PARTICIPATION,
    THIRD_STEP,
    BROKER_FUNDS_PARTICIPATIONS_DECIMALS,
} = require('constants/index');

class ExternalTransferFunDetails extends React.Component {
    getSelectedDestinationFund() {
        const { immExternalTransferFund, immFunds } = this.props;
        const selectedDestinationFund = immExternalTransferFund.getIn([
            'steps',
            THIRD_STEP,
            'destinationFund'
        ]);

        return immFunds.find(immFund => immFund.get('id') == selectedDestinationFund);
    }

    buildLeftContainer() {
        const { immExternalTransferFund, isSuccess } = this.props;
        const originFund = immExternalTransferFund.getIn(['steps', 1, 'label']);
        const originFundContainer =
            originFund && immExternalTransferFund.get('visibleStep') > 1
                ? (<div className={!isSuccess ? 'external-transfer-fund-details__origin-fund' : ''}>
                    <FormattedText value="brokerExternalTransferFundDetails-originFund" />
                    <div className="external-transfer-fund-details__origin-fund-value">
                        {toCamelCase(originFund)}
                    </div>
                </div>)
                : undefined;

        const account = immExternalTransferFund.getIn(['steps', 0, 'account']);
        const nif = immExternalTransferFund.getIn(['steps', 0, 'nif']);
        const hasNif = immExternalTransferFund.getIn(['steps', 0, 'hasNif']);
        return (
            <div>
                <div>
                    {originFundContainer}
                </div>
                <div>
                    <FormattedText
                        value="brokerExternalTransferFundDetails-account"
                        className="external-transfer-fund-details__account"
                    />
                    <div className="external-transfer-fund-details__account-value">
                        {account}
                    </div>
                </div>
                {hasNif &&
                    <div>
                        <FormattedText
                            value="brokerExternalTransferFundDetails-nif"
                            className="external-transfer-fund-details__nif"
                        />
                        <div className="external-transfer-fund-details__nif-value">
                            {nif}
                        </div>
                    </div>
                }
            </div>
        );
    }


    buildRightContainer() {
        const { immExternalTransferFund, isSuccess } = this.props;
        const language = getLanguage();

        const selectedDestinationFund = immExternalTransferFund.getIn([
            'steps',
            2,
            'destinationFund'
        ]);
        let destinationFund;
        if (selectedDestinationFund && immExternalTransferFund.get('visibleStep') > 2) {
            const immFund = this.getSelectedDestinationFund();
            const destinationFundName = immFund.getIn(['name']);
            const immInterveners = immExternalTransferFund.getIn(['interveners','byId']).toIndexedSeq().toArray();
            const interveners = immInterveners.map((immIntervener, index) => {
                const type = formatText(`interventionTypes-${immIntervener.get('desintervencion')}`);
                const name = immIntervener.get('nombre').toUpperCase();
                return(
                    <div className="external-transfer-fund-details__destination-fund-owner" key={index}>
                        {`${type} (${name})`}
                    </div>
                );
            });
            const intervinerSection = (
                <div>
                    {interveners}
                </div>
            );
            destinationFund = (
                <div
                    className={!isSuccess ? 'external-transfer-fund-details__destination-fund' : ''}
                >
                    <FormattedText value="brokerExternalTransferFundDetails-destinationFund" />
                    <div className="external-transfer-fund-details__destination-fund-value">
                        {toCamelCase(destinationFundName)}
                        {intervinerSection}
                    </div>
                </div>
            );
        }
        const type = immExternalTransferFund.getIn(['steps', 2, 'type']);
        let transferType = `brokerExternalTransferFundDetails-type${type}`;
        let transferAmount;
        if (type === BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL) {
            const subType = immExternalTransferFund.getIn(['steps', 2, 'subType']);
            if (subType === BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL_PARTICIPATION) {
                transferType = `${transferType}_participations`;
                const amountParticipation = formatWithoutRound(immExternalTransferFund.getIn(['steps', 2, 'amount']), BROKER_FUNDS_PARTICIPATIONS_DECIMALS);
                const participationLabel = `${formatText('brokerExternalTransferFundDetails-numberParticipations')}: ${amountParticipation}`;
                transferAmount = (
                    <div>
                        {participationLabel}
                    </div>
                );
            }
            else {
                transferType = `${transferType}_amount`;
                const amountObject = {
                    amount: immExternalTransferFund.getIn(['steps', 2, 'amount']),
                    currency: immExternalTransferFund.getIn(['steps', 1, 'currency'])
                };
                const plainAmountObject = getPlainAmountObject(amountObject);
                const amountValue = (
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                    />
                );
                const amountLabel = `${formatText('brokerExternalTransferFundDetails-numberAmount')}: `;
                transferAmount = (
                    <div className="external-transfer-fund-details__parcial-amount">
                        {amountLabel}
                        {amountValue}
                    </div>
                );
            }
        }

        const typeContainer =
            type && immExternalTransferFund.get('visibleStep') > 3
                ? (<div>
                    <FormattedText
                        value="brokerExternalTransferFundDetails-type"
                        className="external-transfer-fund-details__type"
                    />
                    <div className="external-transfer-fund-details__type-value">
                        <FormattedText value={transferType} />
                        {transferAmount}
                    </div>
                </div>)
                : undefined;

        return (
            <div>
                {destinationFund}
                {typeContainer}
            </div>
        );
    }

    render() {
        const { modifier } = this.props;
        const leftContainer = this.buildLeftContainer();
        const rightContainer = this.buildRightContainer();

        const detailsClass = classNames('external-transfer-fund-details', {
            [`external-transfer-fund-details--${modifier}`]: !!modifier
        });

        if (this.props.isSuccess) {
            return (
                <div className={detailsClass}>
                    <div className="external-transfer-fund-details__success">
                        <div className="col-xs-6">
                            {leftContainer}
                        </div>
                        <div className="col-xs-6">
                            {rightContainer}
                        </div>
                    </div>
                    <div className="clearfix" />
                </div>
            );
        } else {
            return (
                <div className={detailsClass}>
                    <FormattedText
                        value="brokerExternalTransferFundDetails-title"
                        className="external-transfer-fund-details__title"
                    />
                    {leftContainer}
                    {rightContainer}
                </div>
            );
        }
    }
}

ExternalTransferFunDetails.propTypes = {
    immExternalTransferFund: PropTypes.object.isRequired,
    immFunds: PropTypes.object.isRequired,
    immFundsList: PropTypes.object.isRequired,
    isSuccess: PropTypes.bool,
    modifier: PropTypes.string
};
module.exports = ExternalTransferFunDetails;
